module.exports = __webpack_public_path__ + "static/6311-5ed340fe2d4b4f3c4a469691298e63a9.png";